import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMeterTypes = async () => {
  return await request.get(
    `/Meter/individual_meter_types`,
    {},
    'При загрузке типов счетчика произошла ошибка'
  );
};

const useFlatMeterTypes = (options) =>
  useQuery(getQueryKeys.flatMeterTypes(), getFlatMeterTypes, options);

export default useFlatMeterTypes;
